import { ExchangeError } from '../../../errors.js';
const ENDPOINT = {
    v1: new URL('https://api2.changelly.com'),
    v2: new URL('https://api.changelly.com/v2/'),
};
const KEYV1 = 'c542e745fe514ed581238e9bea45b74a';
const HEADERS = { 'api-key': KEYV1 };
const getChangellyV1Order = async ({ message, signature, }, fetchival) => {
    const headers = { ...HEADERS, sign: signature };
    const response = await fetchival(ENDPOINT.v1, { headers }).post(message);
    if (!response?.result) {
        throw new ExchangeError({ message: JSON.stringify(response) });
    }
    return response.result[0];
};
const getChangellyV2Order = async ({ jsonRequestBody, headers, }, fetchival) => {
    const response = await fetchival(ENDPOINT.v2, { headers }).post(jsonRequestBody);
    if (!response?.result) {
        throw new ExchangeError({ message: JSON.stringify(response) });
    }
    return response.result[0];
};
const getProviderOrder = async (providerOrder, fetchival) => {
    const getOrderInfo = providerOrder.provider.slug === 'chfv2' ? getChangellyV2Order : getChangellyV1Order;
    if (!providerOrder.options?.statusRequestParams) {
        throw new ExchangeError({ message: 'Missing headers for Changelly' });
    }
    const orderInfo = await getOrderInfo(providerOrder.options.statusRequestParams, fetchival);
    return {
        orderId: orderInfo.id,
        depositAddress: orderInfo.payinAddress,
        depositAmount: orderInfo.amountExpectedFrom,
        withdrawalAddress: orderInfo.payoutAddress,
    };
};
const changellyConfig = {
    ch: getProviderOrder,
    chf: getProviderOrder,
    chfv2: getProviderOrder,
};
export default changellyConfig;
